import { TypedDocumentNode } from '@apollo/client';
import gql from 'graphql-tag';
import { WriteOutlierExceptionInput } from '../Naws';
import { UpdateFormReviewInput } from './schema';

export const updateFormReview = gql`
  mutation UpdateFormReview($input: UpdateFormReviewInput!) {
    updateFormReview(input: $input) {
      code
      message
    }
  }
`;

export const WRITE_OUTLIER_EXCEPTION: TypedDocumentNode<
  { writeOutlierException: string },
  WriteOutlierExceptionInput
> = gql`
  mutation WriteOutlierException(
    $userId: String!
    $deliveredToUsername: String!
    $deliveredToUserId: String!
    $contactId: String!
    $outlierCalYear: String!
    $outlierCalWeek: String!
    $justification: String
  ) {
    writeOutlierException(
      userId: $userId
      deliveredToUsername: $deliveredToUsername
      deliveredToUserId: $deliveredToUserId
      contactId: $contactId
      outlierCalYear: $outlierCalYear
      outlierCalWeek: $outlierCalWeek
      justification: $justification
    )
  }
`;

export const UPDATE_FORM_REVIEW: TypedDocumentNode<
  { updateFormReview: { code: string; message: string } },
  { input: UpdateFormReviewInput }
> = gql`
  mutation UpdateFormReview($input: UpdateFormReviewInput!) {
    updateFormReview(input: $input) {
      code
      message
    }
  }
`;
